import * as React from "react"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore from 'swiper';

import "swiper/swiper-bundle.css"
import { Pagination, EffectCoverflow, Autoplay } from "swiper/modules"
import '../../styles/feedback.css';
import avatar1 from "../../images/featureThumbnail/avatar_feedback1.webp";
import avatar2 from "../../images/featureThumbnail/feedback_avatar2.webp";
import avatar3 from "../../images/featureThumbnail/feedback_avatar3.webp";
import avatar4 from "../../images/featureThumbnail/feedback_avatar4.webp";
import avatar5 from "../../images/featureThumbnail/feedback_avatar5.webp";

import arrowLeft from "../../images/arrow-left.png";
import arrowRight from "../../images/arrow-right.svg";

import Fade from "react-reveal/Fade"
import { useTranslation } from "react-i18next"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import { getCurrentLanguageFromURL, isMobile } from "../../util"
import { useEffect } from "react";
import {Avatar, Divider} from '@mui/material';
import useMediaQuery from "@material-ui/core/useMediaQuery"


SwiperCore.use([Autoplay, Pagination]);


const viFeedbacks = [
	{
		id: 1,
		quote: "Vô tình biết đến Let's Celebrate qua một người bạn giới thiệu. Ban đầu loay hoay không biết chọn mẫu nào, may có các bạn CSKH siêu siêu đáng yêu tư vấn cho để phù hợp với bộ ảnh cưới.\n" +
			"\n" +
			"Đến giờ nghĩ lại không ngờ mình có trải nghiệm mới về thiệp cưới online thú vị và xịn xò đến vậy luôn. \n" +
			"\n" +
			"Dịch vụ CSKH đỉnh lắm nhé, nửa đêm team vẫn support mình rất nhiệt tình!",
		author: "Hà Linh Vũ",
		position: "Cô dâu",
		avatar: avatar1,
	},
	{
		id: 2,
		quote: "Tôi có thể dễ dàng theo dõi danh sách khách mời, RSVP và các thông tin quan trọng khác liên quan đến đám cưới.\n" +
			"\n" +
			"Nhìn chung, tôi hài lòng với dịch vụ thiệp cưới online và các tính năng của Let's Celebrate mà tôi đã sử dụng. Nếu bạn đang tìm kiếm một hình thức thiệp cưới tiết kiệm, tiện lợi và thân thiện với môi trường, tôi highly recommend Let's Celebrate.",
		author: "Peter Nguyen",
		position: "Chú rể",
		avatar: avatar2
	},
	{
		id: 3,
		quote: "Đặc thù công việc của mình đòi hỏi phải mọi thứ phải chính xác và chỉn chu. Vậy nên, mình đã chọn Let’s Celebrate để giúp công việc của mình trở nên tốt hơn. \n" +
			"\n" +
			"Phần mềm có giao diện trực quan và dễ sử dụng, ngay cả đối với những người không rành về công nghệ. Điều làm mình hài lòng nhất là được cung cấp một cái nhìn tổng quan toàn diện về tất cả các khía cạnh của đám cưới. ",
		author: "Kim Minh Hoàng",
		position: "Wedding planner",
		avatar: avatar3
	},
	{
		id: 4,
		quote: "Thích nhất phần Photobook giúp lưu giữ những khoảnh khắc đẹp nhất của mình và người ấy, tạo nên một món quà kỷ niệm ý nghĩa cho cả hai.\n" +
			"\n" +
			"Nhìn chung, mình đánh giá cao sự độc đáo, sáng tạo và tiện lợi của thiệp cưới online của Let's Celebrate mang lại. ",
		author: "Lệ Mai",
		position: "Lập trình viên",
		avatar: avatar4
	},
	{
		id: 5,
		quote: "Kho mẫu thiệp online phong phú, đáp ứng mọi sở thích và yêu cầu của khách hàng. Mình có thể thoải mái kéo thả, chỉnh sửa các chi tiết trong thiệp cưới của mình trong một nốt nhạc. \n" +
			"\n" +
			"Khách mời của mình cảm thấy rất thích thú với thiệp cưới online.",
		author: "Louis Đặng",
		position: "Chú rể",
		avatar: avatar5
	}
];

const enFeedbacks = [
	{
		id: 1,
		quote: "I accidentally learned about Let's Celebrate through a friend's recommendation. I was overwhelmed with the variety of templates and didn't know which one to choose. Fortunately, the lovely customer service team was there to provide me with suggestions that perfectly matched my wedding photos. \n" +
			"\n" +
			"Looking back now, I can't believe I had such a fun and amazing experience with online wedding invitations. ",
		author: "Linh Vu",
		position: "Bride",
		avatar: avatar1,
	},
	{
		id: 2,
		quote: "I was able to easily track my guest list, RSVPs, and other important wedding information.\n" +
			"\n" +
			"Overall, I am very satisfied with the online wedding invitation service and the features of Let's Celebrate that I used. If you are looking for a cost-effective, convenient, and eco-friendly way to send your wedding invitations, I highly recommend Let's Celebrate.",
		author: "Peter Nguyen",
		position: "Groom",
		avatar: avatar2
	},
	{
		id: 3,
		quote: "Due to the nature of my work, I require everything to be precise and detailed. That's why I chose Let's Celebrate to help me improve my work.\n" +
			"\n" +
			"The software has an intuitive and easy-to-use interface, even for those who are not tech-savvy. What I like most is that it provides a comprehensive overview of all aspects of the wedding.",
		author: "Kim Minh Hoang",
		position: "Wedding planner",
		avatar: avatar3
	},
	{
		id: 4,
		quote: "I love the Photobook feature the most, as it allows me to preserve the most precious moments of my partner and me, creating a meaningful keepsake for both of us.\n" +
			"\n" +
			"Overall, I am very impressed with the unique, creative, and convenient online wedding invitations offered by Let's Celebrate.",
		author: "Le Mai",
		position: "Bride",
		avatar: avatar4
	},
	{
		id: 5,
		quote: "A vast collection of online invitation templates caters to every taste and need. I can easily drag and drop and customize every detail of my wedding invitation in a jiffy.\n" +
			"\n" +
			"My guests were thrilled with the online wedding invitation.",
		author: "Louis Dang",
		position: "Groom",
		avatar: avatar5
	}
];


const Feedback = () => {
	
	const {t} = useTranslation();
	
	const swiperRef = React.useRef(null);
	const handlePrevClick = () => {
		swiperRef.current.swiper.slidePrev();
	};
	
	const handleNextClick = () => {
		swiperRef.current.swiper.slideNext();
	};
	
	const language = getCurrentLanguageFromURL();
	const feedbacks = language === 'vi' ? viFeedbacks : enFeedbacks;
	const mobileView = isMobile();
	
	return <>
		<div className='mx-auto rounded-xl max-w-7xl'>
			<Fade>
				<div>
					<h3
						className="text-redTextTitle font-bold text-2xl xxs:text-2xl xs:text-2xl sm:text-lg md:text-2xl lg:text-4xl xl:text-2xl 2xl:text-4xl flex mb-10 justify-center">
						{t(`Khách hàng nói gì về Let's Celebrate`)}
					</h3>
				</div>
			</Fade>
			
			<div className="w-3/4 lg:w-3/4 md:w3/4 xxs:w-full mx-auto feedback-swiper-container">
				<Swiper
					ref={swiperRef}
					spaceBetween={80}
					slidesPerView={1}
					loop={false}
					navigation={{
						nextEl: '.custom-swiper-button-next',
						prevEl: '.custom-swiper-button-prev',
					}}
					pagination={{
						clickable: true,
					}}
					modules={[Pagination]}
					breakpoints={{
						// when window width is >= 320px
						320: {
							slidesPerView: 1,
							spaceBetween: 20
						},
						// when window width is >= 640px
						640: {
							slidesPerView: 1,
							spaceBetween: 80
						}
					}}
					// autoplay={{
					// 	delay: 5000, // Adjust the delay (in ms) as needed
					// 	disableOnInteraction: false, // Keep autoplay enabled even after user interactions
					// 	waitForTransition: true, // Wait for transition to finish before starting the next slide
					// }}
				>
					{feedbacks.map((feedback) => (
						<SwiperSlide key={feedback.id}>
							{/* <div className="w-96 bg-white rounded-lg overflow-hidden shadow-lg">
								<div className="relative h-48">
									<img src={feedback.avatar} alt="Feedback" className="w-full h-full object-cover" />
								</div>
								<div className="p-6">
									<p className="italic text-lg mb-4 text-justify feedback-quote">{`"${feedback.quote}"`}</p>
									<div className="flex flex-row items-center space-x-3">
										<div>
											<p className="font-bold">{feedback.author}</p>
											<p className="text-gray-400 font-semibold">{feedback.position}</p>
										</div>
									</div>
								</div>
							</div> */}
							
							<div className="w-full flex flex-row lg:flex-row md:flex-row mt-10 lg:mt-10 md:mt-10 xxs:mt-0 xxs:flex-col gap-10 bg-white rounded-lg overflow-hidden shadow-lg p-10 lg:p-10 md:p-10 xxs:p-5">
								<div className="w-2/3 lg:w-2/3 md:w-2/3 xxs:w-full">
									<div className='flex'>
										<div className="relative">
											<Avatar src={feedback.avatar} sx={{
												position: 'relative',
												top: '15px'
											}}
											        alt="Feedback" className="object-cover" />
										</div>
										
										<Divider orientation="vertical" flexItem  style={{backgroundColor: '#000', marginLeft: '10px', marginRight: '10px', height: '100% !important'}}/>
										<div>
											<h6 className='font-poppin text-lg'>
												{feedback.author}
											</h6>
											
											<h4 className='text-2xl font-bold'>
												{feedback.position}
											</h4>
										</div>
									</div>
									
									<div className='rounded-xl mt-5' style={{
										backgroundColor: '#f1f1f1',
										whiteSpace: 'pre-wrap',
										wordWrap: 'break-word'
									}}>
										<Box className='rounded-xl p-5' dangerouslySetInnerHTML={{ __html: feedback.quote }}></Box>
									</div>
									
								</div>
								
								<div className=" w-1/3 lg:w-1/3 md:w-1/3 xxs:w-full">
									<img src={feedback.avatar} className='rounded-xl'/>
								</div>
							</div>
							
						</SwiperSlide>
					))}
				</Swiper>
				
				<Stack
					direction='row'
					sx={{
						justifyContent: 'space-between',
						display: 'flex',
						position: 'relative',
						bottom: '200px',
						right: '2.5%',
						width: '105%'
					}}
				>
					<Box onClick={handlePrevClick} className="custom-swiper-button-next"
					     sx={{
						     display: mobileView ? 'none !important' : 'block',
						     '&:hover': {
							     
							     cursor: 'pointer'
						     }
					     }}
					>
						<img src={arrowLeft} alt="Full Screen" width={20} height={20}/>
					</Box>
					
					<Box className="custom-swiper-button-prev" onClick={handleNextClick}
					     sx={{
						     display: mobileView ? 'none !important' : 'block',
						     '&:hover': {
						     	
							     cursor: 'pointer'
						     }
					     }}
					>
						<img src={arrowRight} alt="Full Screen" width={20} height={20}/>
					</Box>
				</Stack>
			</div>
			<div/>
		</div>
	</>
}

export default Feedback;